import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import connect from '@app/utils/connect';

export const CollectionsContext = React.createContext({
    multiSelectOptions: [],
    setMultiSelectOptions: () => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateFilterOptions: _data => {},
});

const CollectionsProvider = ({ children }) => {
    const [multiSelectOptions, setMultiSelectOptions] = useState([]);

    // Creates options for the multiselect filter depending on the current table state
    const updateFilterOptions = useCallback(reactTableData => {
        const creatorNames = [
            ...new Set(reactTableData.map(({ creatorName }) => creatorName)),
        ];
        const multiSelectOptions = creatorNames.sort().reduce((acc, val) => {
            let optionName = val;
            if (val === ' ') {
                optionName = '(Blanks)';
            }
            const newOption = {
                name: optionName,
                id: val,
            };
            acc.push(newOption);
            return acc;
        }, []);
        setMultiSelectOptions(multiSelectOptions);
    }, []);

    const providerValue = {
        multiSelectOptions,
        setMultiSelectOptions,
        updateFilterOptions,
    };

    return (
        <CollectionsContext.Provider value={providerValue}>
            {children}
        </CollectionsContext.Provider>
    );
};

CollectionsProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default connect(['client', 'user', 'settings'])(CollectionsProvider);
